(function() {
  // Function to remove "12 Hours" from the message
  function removeTimeAgo() {
    const el = document.querySelector('#trafficly-message');
    if (el && el.textContent.includes('12 Hours')) {
      el.textContent = el.textContent.replace('12 Hours', '').trim();
    }
  }

  // Run once in case the element already exists
  removeTimeAgo();

  // Observe DOM in case the element is added later or updated
  const observer = new MutationObserver(removeTimeAgo);
  observer.observe(document.body, { childList: true, subtree: true });
})();